import {
    startOfDay,
    endOfDay,
    startOfWeek,
    endOfWeek,
    startOfMonth,
    endOfMonth,
    subDays,
    subWeeks,
    subMonths,
    subYears
} from 'date-fns';
import { uk } from 'date-fns/locale';

export const getDatePresets = () => {
    const now = new Date();

    return [
        {
            id: 'today',
            label: 'Сьогодні',
            getRange: () => ({
                startDate: startOfDay(now),
                endDate: endOfDay(now)
            })
        },
        {
            id: 'yesterday',
            label: 'Вчора',
            getRange: () => ({
                startDate: startOfDay(subDays(now, 1)),
                endDate: endOfDay(subDays(now, 1))
            })
        },
        {
            id: 'thisWeek',
            label: 'Цей тиждень',
            getRange: () => ({
                startDate: startOfWeek(now, { locale: uk }),
                endDate: endOfWeek(now, { locale: uk })
            })
        },
        {
            id: 'lastWeek',
            label: 'Минулий тиждень',
            getRange: () => {
                const lastWeek = subWeeks(now, 1);
                return {
                    startDate: startOfWeek(lastWeek, { locale: uk }),
                    endDate: endOfWeek(lastWeek, { locale: uk })
                };
            }
        },
        {
            id: 'thisMonth',
            label: 'Цей місяць',
            getRange: () => ({
                startDate: startOfMonth(now),
                endDate: endOfMonth(now)
            })
        },
        {
            id: 'lastMonth',
            label: 'Минулий місяць',
            getRange: () => {
                const lastMonth = subMonths(now, 1);
                return {
                    startDate: startOfMonth(lastMonth),
                    endDate: endOfMonth(lastMonth)
                };
            }
        },
        {
            id: 'allTime',
            label: 'Весь час',
            getRange: () => ({
                startDate: startOfDay(subYears(now, 5)),
                endDate: endOfDay(now)
            })
        }
    ];
};

export const getWeekdayLabels = () => ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Нд'];

export const getMonthNames = () => [
    'Січень', 'Лютий', 'Березень', 'Квітень', 'Травень', 'Червень',
    'Липень', 'Серпень', 'Вересень', 'Жовтень', 'Листопад', 'Грудень'
];
